import LRanking from './src/main'

LRanking.install = function(Vue) {
  Vue.component(LRanking.name, LRanking)
}

export default LRanking
